// Docs tab of the API page (/api/docs): the full reference, with this environment's base URL.
import React from 'react';
import ApiReference from './ApiReference';
import { apiBaseUrl } from './apiModel';

export default function ApiDocs() {
  return <ApiReference baseUrl={apiBaseUrl(window.location.origin)} keysLink={{ to: '/api', label: 'Manage your keys' }} />;
}
